import React, { useState } from "react";
import styled from "@emotion/styled";
import { Colors } from "./colors";
import FormControl from "@mui/material/FormControl";
import MuiInputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { mobileWidth } from "./constants";
import { useTranslation } from 'react-i18next';

function getData(role, location, experience, educationLevel) {
  let url =
    "/api/internal/v1/salary/calculate?" +
    new URLSearchParams({
      role: role,
      location_city: location,
      experience_in_yrs: experience,
      education_level: educationLevel,
    });

  fetch(url, { credentials: "same-origin" })
    .then((response) => {
      if (!response.ok) throw Error(response.statusText);
      return response.json();
    })
    .then((data) => {
      this.setState({
        salaries: JSON.parse(data.salaries),
      });
    })
    .catch((error) => console.log(error));
}

const SalaryCalculator = () => {
  const [experience, setExperience] = useState("");
  const [location, setLocation] = useState("");
  const [estimatedSalary, setEstimatedSalary] = useState("");
  const [role, setRole] = useState("software engineer"); // Set default role
  const [educationLevel, setEducationLevel] = useState(""); // Education level state
  const { t, i18n } = useTranslation();

  const calculateSalary = () => {
    // Perform salary calculation based on user inputs (experience, educationLevel, location)
    // Replace this with your actual salary calculation logic
    // const calculatedSalary = getData();
    // setEstimatedSalary(calculatedSalary.toLocaleString() + ' SAR');

    let url =
      "/api/internal/v1/salary/calculate?" +
      new URLSearchParams({
        role: role,
        location_city: location,
        experience_in_yrs: experience,
        education_level: educationLevel,
      });

    fetch(url, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) {
          setEstimatedSalary(
            t("calc_error_msg"),
          );
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        // let parsed_data = JSON.parse(data.salary_per_month_data);

        let parsed_data = data.salary_per_month_data;
        console.log(parsed_data);
        let text = `${parsed_data.min.toLocaleString()} - ${parsed_data.max.toLocaleString()} SAR`;
        setEstimatedSalary(text);
      })
      .catch((error) => console.log(error));
  };
  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleEducationLevelChange = (event) => {
    setEducationLevel(event.target.value);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  return (
    <CalculatorContainer>
      <CalculatorTitle>{t("calc_title")}</CalculatorTitle>
      <InputContainer>
        <InputLabel>{t("calc_years_of_exp")}</InputLabel>
        <InputField
          type="number"
          value={experience}
          onChange={(e) => setExperience(e.target.value)}
        />
      </InputContainer>
      <RoleSelectionContainer>
        <FormControl fullWidth>
          <MuiInputLabel id="role-label">{t("calc_role")}</MuiInputLabel>
          <Select
            labelId="role-label"
            id="role-select"
            value={role}
            label="Role"
            onChange={handleRoleChange}
          >
            <MenuItem value={"software engineer"}>Software Engineer</MenuItem>
            <MenuItem value={"data scientist"}>Data Scientist</MenuItem>
            <MenuItem value={"product manager"}>Product Manager</MenuItem>{" "}
          </Select>
        </FormControl>
      </RoleSelectionContainer>
      <EducationLevelContainer>
        <FormControl fullWidth>
          <MuiInputLabel id="education-label">{t("calc_education_level")}</MuiInputLabel>
          <Select
            labelId="education-label"
            id="education-select"
            value={educationLevel}
            label="Education Level"
            onChange={handleEducationLevelChange}
          >
            <MenuItem value={"highschool"}>High School Diploma</MenuItem>
            <MenuItem value={"bachelor"}>Bachelors Degree</MenuItem>
            <MenuItem value={"master"}>Masters Degree</MenuItem>
            <MenuItem value={"phd"}>PhD</MenuItem>
          </Select>
        </FormControl>
      </EducationLevelContainer>
      <InputContainer>
        <FormControl fullWidth>
          <MuiInputLabel id="location-label">{t("calc_location")}</MuiInputLabel>
          <Select
            labelId="location-label"
            id="location-select"
            value={location}
            label="Location"
            onChange={handleLocationChange}
          >
            <MenuItem value={"Riyadh"}>Riyadh</MenuItem>
            <MenuItem value={"Jeddah"}>Jeddah</MenuItem>
            <MenuItem value={"Dammam"}>Dammam</MenuItem>
            <MenuItem value={"Khobar"}>Khobar</MenuItem>
            <MenuItem value={"Qassim"}>Qassim</MenuItem>
            <MenuItem value={"Taif"}>Taif</MenuItem>
          </Select>
        </FormControl>
      </InputContainer>
      <CalculateButton onClick={calculateSalary}>{t("calc_calculate")}</CalculateButton>
      {estimatedSalary && (
        <ResultContainer>
          <ResultLabel>{t("calc_estimated")}</ResultLabel>
          <Result>{estimatedSalary}</Result>
        </ResultContainer>
      )}
    </CalculatorContainer>
  );
};

const RoleSelectionContainer = styled.div`
  margin-bottom: 15px;
`;

const EducationLevelContainer = styled.div`
  margin-bottom: 15px;
`;

const CalculatorContainer = styled.div`
  width: 35%;
  background-color: ${Colors.primary};
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  padding: 30px;
  color: ${Colors.black};
  @media (max-width: ${mobileWidth}){
    align-self:center;
    width:75vw;
    max-width: 350px;
  }
`;

const CalculatorTitle = styled.h2`
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
`;

const InputContainer = styled.div`
  margin-bottom: 20px;
`;

const InputLabel = styled.label`
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
`;

const InputField = styled.input`
  width: 94%;
  padding: 12px;
  border: 1px solid ${Colors.secondary};
  border-radius: 6px;
  outline: none;
  transition: border-color 0.3s ease-in-out;

  &:focus {
    border-color: ${Colors.moneyGreen};
  }
`;

const StyledSelect = styled(Select)`
  width: 100%;
  margin-top: 12px;
`;

const CalculateButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: ${Colors.moneyGreen};
  color: ${Colors.white};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
`;

const ResultContainer = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const ResultLabel = styled.p`
  font-weight: bold;
`;

const Result = styled.p`
  color: ${Colors.moneyGreen};
  font-size: 20px;
`;
export default SalaryCalculator;
